import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * # ExtubationResults
 * 
 * ExtubationResults을 설명하세요.
 */
export const ExtubationResults = types
  .model('ExtubationResults')
  // --------------------------------------------------------------------------
  .props({
    ext_tf: types.optional(types.number, 0), //  발관 실패 예측 결과 (0/1)
    ext_prob: types.optional(types.string, ''), //  발관 실패 예측 결과 (확률)
    ext_str: types.optional(types.string, ''), //  발관 실패 예측 결과 (성공/실패)
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model extubationResults --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IExtubationResults;
      (Object.keys(newProps) as TExtubationResultsKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TExtubationResults = Instance<typeof ExtubationResults>;
type TExtubationResultsSnapshot = SnapshotOut<typeof ExtubationResults>

export interface IExtubationResults extends TExtubationResults {}
export type TExtubationResultsKeys = keyof TExtubationResultsSnapshot & string;
export interface IExtubationResultsSnapshot extends TExtubationResultsSnapshot {}
export const createExtubationResults = () => 
  types.optional(ExtubationResults, {} as TExtubationResults);